var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PublicPage", {
        attrs: {
          name: _vm.name,
          "platform-code": _vm.platformCode,
          "query-data": _vm.queryData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }